import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../authentication/login";
import LoginFromStaff from "../authentication/login-from-staff";
import PaymentLogin from "../payment/login/login";
import PaymentDashboard from "../payment/dashboard/dashboard";

export default function PublicRoutes() {
    return (
        <div className="main-wrapper">
            <Routes>
                <Route exact path="/" element={<PaymentLogin />} />
                <Route path="/login-from-staff/:id" element={<LoginFromStaff/>}/>
                <Route exact path="/login" element={<PaymentLogin />}/>
                <Route exact path="/portal/payment/dashboard" element={<PaymentDashboard />}/>
                <Route path="*" element={<Login />} />
            </Routes>
        </div>

    );
}